export default {
  API_URL: 'https://comet-dev-api.azurewebsites.net/api',
  SANDBOX_URL: 'https://comet-dev-api.azurewebsites.net/api'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
